import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const QualityAssurancePolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  qualityManagerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Quality_Assurance_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Quality Assurance Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to delivering the highest standards of quality in all aspects of its operations, ensuring customer satisfaction and continual improvement.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all products, services, processes, and activities undertaken by {clientName || "the Company"}.
      </p>

      <h4 className="section-title">3. Quality Objectives</h4>
      <ul>
        <li>Maintain compliance with all relevant regulatory and contractual requirements.</li>
        <li>Deliver products and services that meet or exceed customer expectations.</li>
        <li>Implement effective quality control and assurance processes.</li>
        <li>Promote a culture of continuous improvement throughout the organisation.</li>
      </ul>

      <h4 className="section-title">4. Responsibilities</h4>
      <p className="section-content"><strong>Quality Manager:</strong> Oversees quality assurance programs, audits, and reporting. Contact: {qualityManagerContact || "[Insert Contact Number]"}</p>
      <p className="section-content"><strong>All Employees:</strong> Committed to maintaining quality standards and reporting defects or issues promptly.</p>

      <h4 className="section-title">5. Quality Control Processes</h4>
      <ul>
        <li>Regular audits and inspections to verify compliance and identify areas for improvement.</li>
        <li>Documentation and record-keeping to support traceability and accountability.</li>
        <li>Use of performance metrics and feedback mechanisms to monitor quality.</li>
      </ul>

      <h4 className="section-title">6. Continuous Improvement</h4>
      <p className="section-content">
        {clientName || "The Company"} encourages feedback, innovation, and training initiatives to enhance quality performance and meet evolving customer needs.
      </p>

      <h4 className="section-title">7. Review and Monitoring</h4>
      <p className="section-content">
        This policy will be reviewed annually or as necessary to reflect changes in legislation, technology, or organisational priorities.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to uphold the Quality Assurance Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default QualityAssurancePolicy;
